import React, { useState } from 'react';
import './ContactForm.css';

function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    organizationType: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess("");

    try {
      const res = await fetch("https://gyanvai.com/api/api/sales-enquiry", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      if (res.ok) {
        setSuccess("Thank you! Our sales team will contact you shortly.");
        setForm({
          name: "",
          phone: "",
          email: "",
          organizationType: "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-form">
      <h2 className="text-center mb-2">Enquiry Form</h2>

      <p
        style={{
          textAlign: "center",
          marginBottom: "20px",
          color: "#ccc",
        }}
      >
        Tell us about yourself and we’ll get in touch
      </p>

      {success && (
        <div className="success-message">
          {success}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Full Name</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            placeholder="Enter your full name"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Phone Number</label>
          <input
            type="text"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
            placeholder="Enter phone number"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            required
            placeholder="Enter email address"
            className="form-control"
          />
        </div>

        <div className="form-group">
          <label className="form-label">
            Organization Type
          </label>

          <select
            name="organizationType"
            value={form.organizationType}
            onChange={handleChange}
            required
            className="form-control"
          >
            <option value="">Select Organization Type</option>
            <option value="SCHOOL">School</option>
            <option value="COLLEGE">College</option>
            <option value="UNIVERSITY">University</option>
            <option value="INDUSTRY">Industry</option>
            <option value="OTHER">Other</option>
          </select>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="btn btn-primary w-100"
        >
          {loading ? "Submitting..." : "Submit Enquiry"}
        </button>
      </form>
    </div>
  );
}

export default ContactForm;